/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * ``POST /inbox/chats/{chat_id}/messages`` response.
 */
export interface ChatMessageSendResponse {
  /** @maxLength 255 */
  workflow_id: string;
  message_id?: string | null;
  scheduled_send_at?: string | null;
}
